export default __webpack_public_path__ + "static/media/Group_Health_Insurance_Icon.6f072ce1.svg";